module.exports = __webpack_public_path__ + "img/bg2.0f7d5cf9.png";